// Import here Polyfills if needed. Recommended core-js (npm i -D core-js)
// import "core-js/fn/array.find"
// ...

export class CountermeasureBCA {
  /** Number of Years in the study */
  YearsInStudy: number

  Countermeasure: ICountermeasure
  Site: Segment | Intersection
  CostRecord: CrashCost

  constructor(
    yearsInStudy: number,
    CostRecord: CrashCost,
    countermeasure: ICountermeasure,
    site: Segment | Intersection
  ) {
    this.YearsInStudy = yearsInStudy
    this.Countermeasure = countermeasure
    this.CostRecord = CostRecord
    site.CountermeasureBCA = this
    this.Site = site
  }

  // /**
  //  *
  //  * @param sites Sites within a countermeasure
  //  * @param withCountermeasure Whether to apply countermeasure to crash counts
  //  */
  // aggregateTotalCrashesForCountermeasure(sites: Site[], withCountermeasure: boolean) {
  //   const key = withCountermeasure ? 'TotalCrashesWithCountermeasure' : 'ExpectedTotalCrashes';
  //   return sites.map(site => site[key]).reduce((a: number, b: number) => a + b, 0);
  // }

  // /**
  //  *
  //  * @param sites Sites within a countermeasure
  //  * @param withCountermeasure Whether to apply countermeasure to crash counts
  //  */
  // aggregateFICrashesForCountermeasure(sites: Site[], withCountermeasure: boolean) {
  //   const key = withCountermeasure ? 'FatalInjuryCrashesWithCountermeasure' : 'ExpectedFICrashes';
  //   return sites.map(site => site[key]).reduce((a: number, b: number) => a + b, 0);
  // }

  // Accounting Formula
  get M() {
    const ServiceLife = this.Countermeasure.ServiceLife ? this.Countermeasure.ServiceLife : 0
    if (ServiceLife === 0) console.warn('No value found for Service Life, using 0')
    return (
      (Math.pow(1 + this.CostRecord.DiscountRate, ServiceLife) - 1) /
      (this.CostRecord.DiscountRate * Math.pow(1 + this.CostRecord.DiscountRate, ServiceLife))
    )
  }

  get AnnualConstructionCost() {
    const InitialConstructionCost = this.Countermeasure.InitialConstructionCost
      ? this.Countermeasure.InitialConstructionCost
      : 0
    if (InitialConstructionCost === 0)
      console.warn('No value found for Initial Construction Cost, using 0')
    return InitialConstructionCost / this.M
  }

  get AnnualCost() {
    const AnnualMaintenanceCost = this.Countermeasure.AnnualMaintenanceCost
      ? this.Countermeasure.AnnualMaintenanceCost
      : 0
    if (AnnualMaintenanceCost === 0)
      console.warn('No value found for Annual Maintenance Cost, using 0')
    return this.AnnualConstructionCost + AnnualMaintenanceCost
  }

  get AnnualMaintenanceCost() {
    const AnnualMaintenanceCost = this.Countermeasure.AnnualMaintenanceCost
      ? this.Countermeasure.AnnualMaintenanceCost
      : 0
    if (AnnualMaintenanceCost === 0)
      console.warn('No value found for Annual Maintenance Cost, using 0')
    return AnnualMaintenanceCost
  }
}

export class CrashCost {
  DiscountRate: number
  CrashCostTotal: number // KABCO
  CrashCostFI: number // KABC
  CrashCostPDO: number // O
  CrashCostFatal: number // K
  CrashCostSeriousInjury: number // A
  CrashCostFatalSeriousInjury: number
  /**
   *
   * @param CostRecord contains KABCO, KABC, O values along with a Discount Rate
   *
   * KABCO = Total
   * KABC = FI
   * O = PDO
   */
  constructor({
    KABCO,
    K,
    A,
    KA,
    KABC,
    O,
    DiscountRate
  }: {
    K: number
    A: number
    KABCO: number
    KABC: number
    KA: number
    O: number
    DiscountRate: number
  }) {
    this.CrashCostTotal = KABCO
    this.CrashCostFI = KABC
    this.CrashCostPDO = O
    this.CrashCostFatal = K
    this.CrashCostSeriousInjury = A
    this.DiscountRate = DiscountRate
    this.CrashCostFatalSeriousInjury = KA
  }
}

export interface ICountermeasure {
  TotalCMF?: number
  FICMF?: number
  PDOCMF?: number
  ServiceLife?: number
  InitialConstructionCost?: number
  AnnualMaintenanceCost?: number
}

export abstract class Site {
  TotalObservedCrashes!: number
  PDOObservedCrashes!: number
  FIObservedCrashes!: number
  SeriousInjuryObservedCrashes!: number
  FatalObservedCrashes!: number
  refStatewideProportions!: refStatewideProportions[]
  facilityTypeID!: number
  FromYear!: number
  ToYear!: number
  CountermeasureBCA!: CountermeasureBCA

  get Y() {
    return this.CountermeasureBCA.YearsInStudy
  }

  get TotalCMF() {
    if (!this.CountermeasureBCA.Countermeasure.TotalCMF) return 1
    else return this.CountermeasureBCA.Countermeasure.TotalCMF
  }

  get FICMF() {
    if (!this.CountermeasureBCA.Countermeasure.FICMF) return this.TotalCMF
    else return this.CountermeasureBCA.Countermeasure.FICMF
  }

  get PDOCMF() {
    if (!this.CountermeasureBCA.Countermeasure.PDOCMF) return this.TotalCMF
    else return this.CountermeasureBCA.Countermeasure.PDOCMF
  }

  get CrashCostFI() {
    return this.CountermeasureBCA.CostRecord.CrashCostFI
  }

  get CrashCostPDO() {
    return this.CountermeasureBCA.CostRecord.CrashCostPDO
  }

  get CrashCostFatal() {
    return this.CountermeasureBCA.CostRecord.CrashCostFatal
  }

  get CrashCostSeriousInjury() {
    return this.CountermeasureBCA.CostRecord.CrashCostSeriousInjury
  }

  get AnnualCost() {
    return this.CountermeasureBCA.AnnualCost
  }

  get AnnualConstructionCost() {
    return this.CountermeasureBCA.AnnualConstructionCost
  }

  get AnnualMaintenanceCost() {
    return this.CountermeasureBCA.AnnualMaintenanceCost
  }

  get KProportion() {
    let statewideProportion = this.refStatewideProportions.filter(
      x =>
        x.FacilityTypeID == this.facilityTypeID &&
        x.CaseYear >= this.FromYear &&
        x.CaseYear <= this.ToYear
    )
    const sum = statewideProportion.reduce((a, b) => a + b.K, 0)
    const tot = statewideProportion.reduce((a, b) => a + (b.K + b.A + b.B + b.C), 0)
    if (tot != 0) {
      return (1.0 * sum) / tot
    }
    return 0
  }

  get AProportion() {
    let statewideProportion = this.refStatewideProportions.filter(
      x =>
        x.FacilityTypeID == this.facilityTypeID &&
        x.CaseYear >= this.FromYear &&
        x.CaseYear <= this.ToYear
    )
    const sum = statewideProportion.reduce((a, b) => a + b.A, 0)
    const tot = statewideProportion.reduce((a, b) => a + (b.K + b.A + b.B + b.C), 0)
    if (tot != 0) {
      return (1.0 * sum) / tot
    }
    return 0
  }

  get KAProportion() {
    let statewideProportion = this.refStatewideProportions.filter(
      x =>
        x.FacilityTypeID == this.facilityTypeID &&
        x.CaseYear >= this.FromYear &&
        x.CaseYear <= this.ToYear
    )
    const sum = statewideProportion.reduce((a, b) => a + b.K + b.A, 0)
    const tot = statewideProportion.reduce((a, b) => a + (b.K + b.A + b.B + b.C), 0)
    if (tot != 0) {
      return (1.0 * sum) / tot
    }
    return 0
  }
}

export class refStatewideProportions {
  ID!: number
  CaseYear!: number
  FacilityTypeID!: number
  CrashTypeCategoryID!: number
  K!: number
  A!: number
  B!: number
  C!: number
  O!: number
}

export class Segment extends Site {
  private ADT: number
  private L: number

  // private TotalDispersionParameter: number = 0.5
  // private FIDispersionParameter: number = 0.67
  private SPF: SPFSiteInfo
  constructor({
    TotalCrashCount,
    PDOCrashCount,
    FatalCrashCount,
    SeriousInjuryCrashCount,
    FICrashCount,
    SegmentLength,
    AADT_1,
    SPF
  }: {
    FatalCrashCount: number
    SeriousInjuryCrashCount: number
    TotalCrashCount: number
    PDOCrashCount: number
    FICrashCount: number
    SegmentLength: number
    AADT_1: number
    SPF: SPFSiteInfo
  }) {
    super()
    this.ADT = AADT_1
    this.L = SegmentLength
    this.TotalObservedCrashes = TotalCrashCount
    this.PDOObservedCrashes = PDOCrashCount
    this.FIObservedCrashes = FICrashCount
    this.FatalObservedCrashes = FatalCrashCount
    this.SeriousInjuryObservedCrashes = SeriousInjuryCrashCount
    this.SPF = SPF
  }

  get TotalLossCalculation() {
    let LOSS = null
    let Alpha = this.K_Total == 0 ? 0 : 1 / this.K_Total
    let Beta = Alpha == 0 ? 0 : this.TotalPredictedCrashes / Alpha
    let LossCalc: LossCalculation = new LossCalculation()
    let G1 = LossCalc.GammaInv(0.1, Alpha, Beta)
    let G5 = this.TotalPredictedCrashes ?? 0
    let G9 = LossCalc.GammaInv(0.9, Alpha, Beta)
    LOSS = 1
    if (this.AnnualTotalExpectedCrashes >= G1) LOSS = 2
    if (this.AnnualTotalExpectedCrashes >= G5) LOSS = 3
    if (this.AnnualTotalExpectedCrashes >= G9) LOSS = 4
    if (G1 == 0 && G5 == 0 && G9 == 0) LOSS = 0 //1.0.6.2
    if (this.AnnualTotalExpectedCrashes == null) LOSS = null
    return LOSS
  }

  get KALossCalculation() {
    let LOSS = null
    let Alpha = this.K_FI == 0 ? 0 : 1 / this.K_FI
    let Beta = Alpha == 0 ? 0 : this.KAPredictedCrashesProportion / Alpha
    let LossCalc: LossCalculation = new LossCalculation()
    let G1 = LossCalc.GammaInv(0.1, Alpha, Beta)
    let G5 = this.KAPredictedCrashesProportion ?? 0
    let G9 = LossCalc.GammaInv(0.9, Alpha, Beta)
    LOSS = 1
    if (this.AnnualKAExpectedCrashes >= G1) LOSS = 2
    if (this.AnnualKAExpectedCrashes >= G5) LOSS = 3
    if (this.AnnualKAExpectedCrashes >= G9) LOSS = 4
    if (G1 == 0 && G5 == 0 && G9 == 0) LOSS = 0 //1.0.6.2
    if (this.AnnualKAExpectedCrashes == null) LOSS = null
    return LOSS
  }

  get FILossCalculation() {
    let LOSS = null
    let Alpha = this.K_FI == 0 ? 0 : 1 / this.K_FI
    let Beta = Alpha == 0 ? 0 : this.FIPredictedCrashes / Alpha
    let LossCalc: LossCalculation = new LossCalculation()
    let G1 = LossCalc.GammaInv(0.1, Alpha, Beta)
    let G5 = this.FIPredictedCrashes ?? 0
    let G9 = LossCalc.GammaInv(0.9, Alpha, Beta)
    LOSS = 1
    if (this.AnnualFIExpectedCrashes >= G1) LOSS = 2
    if (this.AnnualFIExpectedCrashes >= G5) LOSS = 3
    if (this.AnnualFIExpectedCrashes >= G9) LOSS = 4
    if (G1 == 0 && G5 == 0 && G9 == 0) LOSS = 0 //1.0.6.2
    if (this.AnnualFIExpectedCrashes == null) LOSS = null
    return LOSS
  }

  //#region Total
  get TotalPredictedCrashes() {
    return (
      this.SPF.TotalSPFInfo.CA *
      Math.pow(
        Math.pow(this.ADT, this.SPF.TotalSPFInfo.B1) *
          Math.pow(this.L, this.SPF.TotalSPFInfo.BL) *
          Math.pow(Math.E, this.SPF.TotalSPFInfo.BC + this.SPF.TotalSPFInfo.B2 * this.ADT),
        this.SPF.TotalSPFInfo.CB
      )
    )
  }

  get K_Total() {
    return (
      this.SPF.TotalSPFInfo.D1 *
      Math.pow(this.L, this.SPF.TotalSPFInfo.D2) *
      Math.pow(Math.E, this.SPF.TotalSPFInfo.D3 * Math.pow(this.L, this.SPF.TotalSPFInfo.D4))
    )
  }

  get WeightTotal() {
    return 1 / (1 + this.K_Total * this.TotalPredictedCrashes * this.Y)
  }

  get TotalExpectedCrashes() {
    return (
      this.WeightTotal * (this.TotalPredictedCrashes * this.Y) +
      (1 - this.WeightTotal) * this.TotalObservedCrashes
    )
  }

  get AnnualTotalExpectedCrashes() {
    return this.TotalExpectedCrashes / this.Y
  }

  get TotalExpectedCrashesWithCountermeasure() {
    return this.AnnualTotalExpectedCrashes * this.TotalCMF
  }

  get AnnualBenefitTotal() {
    return this.AnnualBenefitFI + this.AnnualBenefitPDO
  }

  /** DEPRACTED (DO NOT USE THIS)
   * This libary needs to be rewriten to use this. This method will give incorrect calculation and is done
   * outside of this libary Search code for 'CalculateBCRatio'
   */
  get TotalBCR() {
    return this.AnnualBenefitTotal / this.AnnualCost
  }
  //#endregion

  //#region FI (KABC)
  get FIPredictedCrashes() {
    return (
      this.SPF.FatalSPFInfo.CA *
      Math.pow(
        Math.pow(this.ADT, this.SPF.FatalSPFInfo.B1) *
          Math.pow(this.L, this.SPF.FatalSPFInfo.BL) *
          Math.pow(Math.E, this.SPF.FatalSPFInfo.BC + this.SPF.FatalSPFInfo.B2 * this.ADT),
        this.SPF.FatalSPFInfo.CB
      )
    )
  }

  get K_FI() {
    return (
      this.SPF.FatalSPFInfo.D1 *
      Math.pow(this.L, this.SPF.FatalSPFInfo.D2) *
      Math.pow(Math.E, this.SPF.FatalSPFInfo.D3 * Math.pow(this.L, this.SPF.FatalSPFInfo.D4))
    )
  }

  get WeightFI() {
    return 1 / (1 + this.K_FI * this.FIPredictedCrashes * this.Y)
  }

  get FIExpectedCrashes() {
    return (
      this.WeightFI * (this.FIPredictedCrashes * this.Y) +
      (1 - this.WeightFI) * this.FIObservedCrashes
    )
  }

  get AnnualFIExpectedCrashes() {
    return this.FIExpectedCrashes / this.Y
  }

  get FIExpectedCrashesWithCountermeasure() {
    return this.AnnualFIExpectedCrashes * this.FICMF
  }

  get AnnualBenefitFI() {
    const difference = this.AnnualFIExpectedCrashes - this.FIExpectedCrashesWithCountermeasure
    return difference * this.CrashCostFI
  }

  get FIBCR() {
    return this.AnnualBenefitFI / this.AnnualCost
  }
  //#endregion

  //#region K (using FI)
  get AnnualKPredictedCrashes() {
    return this.FIPredictedCrashes * this.KProportion
  }

  get WeightK() {
    return 1 / (1 + this.K_FI * this.AnnualKPredictedCrashes * this.Y)
  }

  get FatalExpectedCrashes() {
    return (
      this.WeightFI * (this.AnnualKPredictedCrashes * this.Y) +
      (1 - this.WeightFI) * this.FatalObservedCrashes
    )
  }

  get AnnualFatalExpectedCrashes() {
    return this.FatalExpectedCrashes / this.Y
  }

  get FatalExpectedCrashesWithCountermeasure() {
    return this.AnnualFatalExpectedCrashes / this.Y
  }

  get AnnualBenefitFatal() {
    const difference = this.AnnualFatalExpectedCrashes - this.FatalExpectedCrashesWithCountermeasure
    return difference * this.CrashCostFatal
  }

  get FatalBCR() {
    return this.AnnualBenefitFatal / this.AnnualCost
  }
  //#endregion

  //#region A (using FI)
  get AnnualAPredictedCrashes() {
    return this.FIPredictedCrashes * this.AProportion
  }

  get WeightA() {
    return 1 / (1 + this.K_FI * this.AnnualAPredictedCrashes * this.Y)
  }

  get SeriousInjuryExpectedCrashes() {
    return (
      this.WeightA * (this.AnnualAPredictedCrashes * this.Y) +
      (1 - this.WeightA) * this.SeriousInjuryObservedCrashes
    )
  }

  get AnnualSeriousInjuryExpectedCrashes() {
    return this.SeriousInjuryExpectedCrashes / this.Y
  }

  get SeriousInjuryExpectedCrashesWithCountermeasure() {
    return this.AnnualSeriousInjuryExpectedCrashes / this.Y
  }

  get AnnualBenefitSeriousInjury() {
    const difference =
      this.AnnualSeriousInjuryExpectedCrashes - this.SeriousInjuryExpectedCrashesWithCountermeasure
    return difference * this.CrashCostSeriousInjury
  }

  get SeriousInjuryBCR() {
    return this.AnnualBenefitSeriousInjury / this.AnnualCost
  }
  //#endregion

  //#region KA
  get KAPredictedCrashesProportion() {
    return this.FIPredictedCrashes * this.KAProportion
  }

  get WeightKA() {
    return 1 / (1 + this.K_FI * this.KAPredictedCrashesProportion * this.Y)
  }

  get KAExpectedCrashes() {
    return (
      this.WeightKA * (this.KAPredictedCrashesProportion * this.Y) +
      (1 - this.WeightKA) * (this.FatalObservedCrashes + this.SeriousInjuryObservedCrashes)
    )
  }

  get AnnualKAExpectedCrashes() {
    return this.KAExpectedCrashes / this.Y
  }

  get KACrashesWithCountermeasure() {
    return this.AnnualKAExpectedCrashes / this.Y
  }

  get AnnualBenefitFatalAndSeriousInjury() {
    const difference = this.AnnualKAExpectedCrashes - this.KACrashesWithCountermeasure
    return difference * (this.CrashCostFatal + this.CrashCostSeriousInjury)
  }

  get FatalAndSeriousInjuryBCR() {
    return this.FatalBCR + this.SeriousInjuryBCR
  }
  //#endregion

  //#region PDO
  get PDOPredictedCrashes() {
    return this.TotalPredictedCrashes - this.FIPredictedCrashes
  }

  get AnnualPDOExpectedCrashes() {
    return this.AnnualTotalExpectedCrashes - this.AnnualFIExpectedCrashes
  }

  get PDOExpectedCrashesWithCountermeasure() {
    return this.AnnualPDOExpectedCrashes * this.PDOCMF
  }

  get AnnualBenefitPDO() {
    const difference = this.AnnualPDOExpectedCrashes - this.PDOExpectedCrashesWithCountermeasure
    return difference * this.CrashCostPDO
  }
  //#endregion
}

export class Intersection extends Site {
  private major_ADT: number
  private minor_ADT: number
  private SPF: SPFSiteInfo
  constructor({
    TotalCrashCount,
    PDOCrashCount,
    FatalCrashCount,
    SeriousInjuryCrashCount,
    FICrashCount,
    AADT_1,
    AADT_2,
    SPF
  }: {
    FatalCrashCount: number
    SeriousInjuryCrashCount: number
    TotalCrashCount: number
    PDOCrashCount: number
    FICrashCount: number
    AADT_1: number
    AADT_2: number
    SPF: SPFSiteInfo
  }) {
    super()
    this.major_ADT = AADT_1
    this.minor_ADT = AADT_2
    this.TotalObservedCrashes = TotalCrashCount
    this.PDOObservedCrashes = PDOCrashCount
    this.FIObservedCrashes = FICrashCount
    this.FatalObservedCrashes = FatalCrashCount
    this.SeriousInjuryObservedCrashes = SeriousInjuryCrashCount
    this.SPF = SPF
  }

  get TotalLossCalculation() {
    let LOSS = null
    let Alpha = this.K_Total == 0 ? 0 : 1 / this.K_Total
    let Beta = Alpha == 0 ? 0 : this.TotalPredictedCrashes / Alpha
    let LossCalc: LossCalculation = new LossCalculation()
    let G1 = LossCalc.GammaInv(0.1, Alpha, Beta)
    let G5 = this.TotalPredictedCrashes ?? 0
    let G9 = LossCalc.GammaInv(0.9, Alpha, Beta)
    LOSS = 1
    if (this.AnnualTotalExpectedCrashes >= G1) LOSS = 2
    if (this.AnnualTotalExpectedCrashes >= G5) LOSS = 3
    if (this.AnnualTotalExpectedCrashes >= G9) LOSS = 4
    if (G1 == 0 && G5 == 0 && G9 == 0) LOSS = 0 //1.0.6.2
    if (this.AnnualTotalExpectedCrashes == null) LOSS = null
    return LOSS
  }

  get KALossCalculation() {
    let LOSS = null
    let Alpha = this.K_FI == 0 ? 0 : 1 / this.K_FI
    let Beta = Alpha == 0 ? 0 : this.KAPredictedCrashesProportion / Alpha
    let LossCalc: LossCalculation = new LossCalculation()
    let G1 = LossCalc.GammaInv(0.1, Alpha, Beta)
    let G5 = this.KAPredictedCrashesProportion ?? 0
    let G9 = LossCalc.GammaInv(0.9, Alpha, Beta)
    LOSS = 1
    if (this.AnnualKAExpectedCrashes >= G1) LOSS = 2
    if (this.AnnualKAExpectedCrashes >= G5) LOSS = 3
    if (this.AnnualKAExpectedCrashes >= G9) LOSS = 4
    if (G1 == 0 && G5 == 0 && G9 == 0) LOSS = 0 //1.0.6.2
    if (this.AnnualKAExpectedCrashes == null) LOSS = null
    return LOSS
  }

  get FILossCalculation() {
    let LOSS = null
    let Alpha = this.K_FI == 0 ? 0 : 1 / this.K_FI
    let Beta = Alpha == 0 ? 0 : this.FIPredictedCrashes / Alpha
    let LossCalc: LossCalculation = new LossCalculation()
    let G1 = LossCalc.GammaInv(0.1, Alpha, Beta)
    let G5 = this.FIPredictedCrashes ?? 0
    let G9 = LossCalc.GammaInv(0.9, Alpha, Beta)
    LOSS = 1
    if (this.AnnualFIExpectedCrashes >= G1) LOSS = 2
    if (this.AnnualFIExpectedCrashes >= G5) LOSS = 3
    if (this.AnnualFIExpectedCrashes >= G9) LOSS = 4
    if (G1 == 0 && G5 == 0 && G9 == 0) LOSS = 0 //1.0.6.2
    if (this.AnnualFIExpectedCrashes == null) LOSS = null
    return LOSS
  }

  //#region Total
  get TotalPredictedCrashes() {
    return (
      this.SPF.TotalSPFInfo.CA *
      Math.pow(
        Math.pow(this.major_ADT, this.SPF.TotalSPFInfo.B1) *
          Math.pow(this.minor_ADT, this.SPF.TotalSPFInfo.B2) *
          Math.pow(Math.E, this.SPF.TotalSPFInfo.BC),
        this.SPF.TotalSPFInfo.CB
      )
    )
  }

  get K_Total() {
    return (
      this.SPF.TotalSPFInfo.D1 *
      Math.pow(1, this.SPF.TotalSPFInfo.D2) *
      Math.pow(Math.E, this.SPF.TotalSPFInfo.D3 * Math.pow(1, this.SPF.TotalSPFInfo.D4))
    )
  }

  get WeightTotal() {
    return 1 / (1 + this.K_Total * this.TotalPredictedCrashes * this.Y)
  }

  get TotalExpectedCrashes() {
    return (
      this.WeightTotal * (this.TotalPredictedCrashes * this.Y) +
      (1 - this.WeightTotal) * this.TotalObservedCrashes
    )
  }

  get AnnualTotalExpectedCrashes() {
    return this.TotalExpectedCrashes / this.Y
  }

  get TotalExpectedCrashesWithCountermeasure() {
    return this.AnnualTotalExpectedCrashes * this.TotalCMF
  }

  get AnnualBenefitTotal() {
    return this.AnnualBenefitFI + this.AnnualBenefitPDO
  }

  get TotalBCR() {
    return this.AnnualBenefitTotal / this.AnnualCost
  }
  //#endregion

  //#region FI (KABC)
  get FIPredictedCrashes() {
    return (
      this.SPF.FatalSPFInfo.CA *
      Math.pow(
        Math.pow(this.major_ADT, this.SPF.FatalSPFInfo.B1) *
          Math.pow(this.minor_ADT, this.SPF.FatalSPFInfo.B2) *
          Math.pow(Math.E, this.SPF.FatalSPFInfo.BC),
        this.SPF.FatalSPFInfo.CB
      )
    )
  }

  get K_FI() {
    return (
      this.SPF.FatalSPFInfo.D1 *
      Math.pow(1, this.SPF.FatalSPFInfo.D2) *
      Math.pow(Math.E, this.SPF.FatalSPFInfo.D3 * Math.pow(1, this.SPF.FatalSPFInfo.D4))
    )
  }

  get WeightFI() {
    return 1 / (1 + this.K_FI * this.FIPredictedCrashes * this.Y)
  }

  get FIExpectedCrashes() {
    return (
      this.WeightFI * (this.FIPredictedCrashes * this.Y) +
      (1 - this.WeightFI) * this.FIObservedCrashes
    )
  }

  get AnnualFIExpectedCrashes() {
    return this.FIExpectedCrashes / this.Y
  }

  get FIExpectedCrashesWithCountermeasure() {
    return this.AnnualFIExpectedCrashes * this.FICMF
  }

  get AnnualBenefitFI() {
    const difference = this.AnnualFIExpectedCrashes - this.FIExpectedCrashesWithCountermeasure
    return difference * this.CrashCostFI
  }

  get FIBCR() {
    return this.AnnualBenefitFI / this.AnnualCost
  }
  //#endregion

  //#region PDO
  get PDOPredictedCrashes() {
    return this.TotalPredictedCrashes - this.FIPredictedCrashes
  }

  get AnnualPDOExpectedCrashes() {
    return this.AnnualTotalExpectedCrashes - this.AnnualFIExpectedCrashes
  }

  get PDOExpectedCrashesWithCountermeasure() {
    return this.AnnualPDOExpectedCrashes * this.PDOCMF
  }

  get AnnualBenefitPDO() {
    const difference = this.AnnualPDOExpectedCrashes - this.PDOExpectedCrashesWithCountermeasure
    return difference * this.CrashCostPDO
  }
  //#endregion

  //#region K (using FI)
  get FatalExpectedCrashes() {
    return (
      this.WeightFI * (this.FIPredictedCrashes * this.Y) +
      (1 - this.WeightFI) * this.FatalObservedCrashes
    )
  }

  get AnnualFatalExpectedCrashes() {
    return this.FatalExpectedCrashes / this.Y
  }

  get FatalExpectedCrashesWithCountermeasure() {
    return this.AnnualFatalExpectedCrashes / this.Y
  }

  get AnnualBenefitFatal() {
    const difference = this.AnnualFatalExpectedCrashes - this.FatalExpectedCrashesWithCountermeasure
    return difference * this.CrashCostFatal
  }

  get FatalBCR() {
    return this.AnnualBenefitFatal / this.AnnualCost
  }
  //#endregion

  //#region A (using FI)
  get SeriousInjuryExpectedCrashes() {
    return (
      this.WeightFI * (this.FIPredictedCrashes * this.Y) +
      (1 - this.WeightFI) * this.SeriousInjuryObservedCrashes
    )
  }

  get AnnualSeriousInjuryExpectedCrashes() {
    return this.SeriousInjuryExpectedCrashes / this.Y
  }

  get SeriousInjuryExpectedCrashesWithCountermeasure() {
    return this.AnnualSeriousInjuryExpectedCrashes / this.Y
  }

  get AnnualBenefitSeriousInjury() {
    const difference =
      this.AnnualSeriousInjuryExpectedCrashes - this.SeriousInjuryExpectedCrashesWithCountermeasure
    return difference * this.CrashCostSeriousInjury
  }

  get SeriousInjuryBCR() {
    return this.AnnualBenefitSeriousInjury / this.AnnualCost
  }
  //#endregion

  //#region KA
  get KAPredictedCrashesProportion() {
    return this.FIPredictedCrashes * this.KAProportion
  }

  get WeightKA() {
    return 1 / (1 + this.K_FI * this.KAPredictedCrashesProportion * this.Y)
  }

  get KAExpectedCrashes() {
    return (
      this.WeightKA * (this.KAPredictedCrashesProportion * this.Y) +
      (1 - this.WeightKA) * (this.FatalObservedCrashes + this.SeriousInjuryObservedCrashes)
    )
  }

  get AnnualKAExpectedCrashes() {
    return this.KAExpectedCrashes / this.Y
  }

  get KACrashesWithCountermeasure() {
    return this.AnnualKAExpectedCrashes / this.Y
  }

  get AnnualBenefitFatalAndSeriousInjury() {
    const difference = this.AnnualKAExpectedCrashes - this.KACrashesWithCountermeasure
    return difference * (this.CrashCostFatal + this.CrashCostSeriousInjury)
  }

  get FatalAndSeriousInjuryBCR() {
    return this.FatalBCR + this.SeriousInjuryBCR
  }
  //#endregion
}

export class SegmentCMF extends Site {
  SPF: SPFInfo
  private BeforeAADT: number
  private AADT: number
  private L: number
  private ObservedAfterCrash: number
  private ObservedBeforeCrash: number

  constructor(
    AADT: number,
    BeforeAADT: number,
    L: number,
    ObservedAfterCrash: number,
    ObservedBeforeCrash: number,
    SPF: SPFInfo
  ) {
    super()
    this.SPF = SPF
    this.AADT = AADT
    this.BeforeAADT = BeforeAADT
    this.L = L
    this.ObservedAfterCrash = ObservedAfterCrash
    this.ObservedBeforeCrash = ObservedBeforeCrash
  }

  //#region Total
  //Formula: CA * (AADT^B1 * L^B_L * e^(BCant + B2 * AADT))^CB
  get BeforePredictedCrashes() {
    return (
      this.SPF.CA *
      Math.pow(
        Math.pow(this.BeforeAADT, this.SPF.B1) *
          Math.pow(this.L, this.SPF.BL) *
          Math.pow(Math.E, this.SPF.BC + this.SPF.B2 * this.AADT),
        this.SPF.CB
      )
    )
  }

  get AfterPredictedCrashes() {
    return (
      this.SPF.CA *
      Math.pow(
        Math.pow(this.AADT, this.SPF.B1) *
          Math.pow(this.L, this.SPF.BL) *
          Math.pow(Math.E, this.SPF.BC + this.SPF.B2 * this.AADT),
        this.SPF.CB
      )
    )
  }

  get ExpectedBeforeCrashes() {
    return (
      this.weightingFactor * this.BeforePredictedCrashes +
      (1 - this.weightingFactor) * this.ObservedBeforeCrash
    )
  }

  get weightingFactor() {
    return 1 /*commented out for now
    / (1 + this.SPF.OD_A * this.BeforePredictedCrashes)
    */
  }

  get ExpectedAfterCrashes() {
    return this.ExpectedBeforeCrashes * (this.AfterPredictedCrashes / this.BeforePredictedCrashes)
  }

  get VarianceExpectedAfter() {
    return (
      this.ExpectedAfterCrashes *
      (this.AfterPredictedCrashes / this.BeforePredictedCrashes) *
      (1 - this.weightingFactor)
    )
  }

  get NewCMF() {
    return (
      this.ObservedAfterCrash /
      this.ExpectedAfterCrashes /
      (1 + Math.pow(this.VarianceExpectedAfter / this.ExpectedAfterCrashes, 2))
    )
  }

  get StandardErrorCMF() {
    return Math.sqrt(
      (Math.pow(this.NewCMF, 2) *
        (1 / this.ObservedAfterCrash) *
        (this.VarianceExpectedAfter / Math.pow(this.ExpectedAfterCrashes, 2))) /
        (1 + this.VarianceExpectedAfter / Math.pow(this.ExpectedAfterCrashes, 2))
    )
  }
}

export class IntersectionCMF extends Site {
  SPF: SPFInfo
  private BeforeAADT_Major: number
  private BeforeAADT_Minor: number
  private AADT_Major: number
  private AADT_Minor: number
  private ObservedAfterCrash: number
  private ObservedBeforeCrash: number

  constructor(
    AADT_Major: number,
    AADT_Minor: number,
    BeforeAADT_Major: number,
    BeforeAADT_Minor: number,
    ObservedAfterCrash: number,
    ObservedBeforeCrash: number,
    SPF: SPFInfo
  ) {
    super()
    this.SPF = SPF
    this.AADT_Major = AADT_Major
    this.AADT_Minor = AADT_Minor
    this.BeforeAADT_Major = BeforeAADT_Major
    this.BeforeAADT_Minor = BeforeAADT_Minor
    this.ObservedAfterCrash = ObservedAfterCrash
    this.ObservedBeforeCrash = ObservedBeforeCrash
  }

  //#region Total
  //Formula: CA * (AADT_Major^B_Maj * AADT_Minor^B_Min * e^(BCant))^CB
  get BeforePredictedCrashes() {
    return (
      this.SPF.CA *
      Math.pow(
        Math.pow(this.BeforeAADT_Major, this.SPF.B1) *
          Math.pow(this.BeforeAADT_Minor, this.SPF.B2) *
          Math.pow(Math.E, this.SPF.BC),
        this.SPF.CB
      )
    )
  }

  get AfterPredictedCrashes() {
    return (
      this.SPF.CA *
      Math.pow(
        Math.pow(this.AADT_Major, this.SPF.B1) *
          Math.pow(this.AADT_Minor, this.SPF.B2) *
          Math.pow(Math.E, this.SPF.BC),
        this.SPF.CB
      )
    )
  }

  get ExpectedBeforeCrashes() {
    return (
      this.weightingFactor * this.BeforePredictedCrashes +
      (1 - this.weightingFactor) * this.ObservedBeforeCrash
    )
  }

  get weightingFactor() {
    return 1 /*commented out for now
    / (1 + this.SPF.OD_A * this.BeforePredictedCrashes)
    */
  }

  get ExpectedAfterCrashes() {
    return this.ExpectedBeforeCrashes * (this.AfterPredictedCrashes / this.BeforePredictedCrashes)
  }

  get VarianceExpectedAfter() {
    return (
      this.ExpectedAfterCrashes *
      (this.AfterPredictedCrashes / this.BeforePredictedCrashes) *
      (1 - this.weightingFactor)
    )
  }

  get NewCMF() {
    return (
      this.ObservedAfterCrash /
      this.ExpectedAfterCrashes /
      (1 + Math.pow(this.VarianceExpectedAfter / this.ExpectedAfterCrashes, 2))
    )
  }

  get StandardErrorCMF() {
    return Math.sqrt(
      (Math.pow(this.NewCMF, 2) *
        (1 / this.ObservedAfterCrash) *
        (this.VarianceExpectedAfter / Math.pow(this.ExpectedAfterCrashes, 2))) /
        (1 + this.VarianceExpectedAfter / Math.pow(this.ExpectedAfterCrashes, 2))
    )
  }
}

export class SPFSiteInfo {
  TotalSPFInfo: SPFInfo
  FatalSPFInfo: SPFInfo

  constructor(TotalSPFInfo: SPFInfo, FatalSPFInfo: SPFInfo) {
    this.TotalSPFInfo = TotalSPFInfo
    this.FatalSPFInfo = FatalSPFInfo
  }
}

export class SPFInfo {
  ScreenType: string
  FacilityTypeId: string
  SPFYear: string
  Severity: string
  /*Zachary Pappalau 2/6/2023
  //DEPRACTED: These underscore varibles are not being used anymore and
  Are replace with the non-underscore varibles underneath*/
  /*OD_A: number
  OD_B: number
  OD_C: number
  OD_D: number
  C_a: number
  C_b: number
  B_aadt: number
  B_aadt2: number
  B_len: number
  B_const: number
  B_hoerl number*/
  CA: number
  CB: number
  B1: number
  B2: number
  BC: number
  BL: number
  D1: number
  D2: number
  D3: number
  D4: number

  constructor(SPFRecord: SPFInfo) {
    this.ScreenType = SPFRecord.ScreenType
    this.FacilityTypeId = SPFRecord.FacilityTypeId
    this.SPFYear = SPFRecord.SPFYear
    this.Severity = SPFRecord.Severity
    /*this.OD_A = SPFRecord.OD_A
    this.OD_B = SPFRecord.OD_B
    this.OD_C = SPFRecord.OD_C
    this.OD_D = SPFRecord.OD_D
    this.C_a = SPFRecord.C_a
    this.C_b = SPFRecord.C_b
    this.B_aadt = SPFRecord.B_aadt
    this.B_aadt2 = SPFRecord.B_aadt2
    this.B_len = SPFRecord.B_len
    this.B_const = SPFRecord.B_const
    this.B_hoerl = SPFRecord.B_hoerl*/
    this.CA = SPFRecord.CA
    this.CB = SPFRecord.CB
    this.B1 = SPFRecord.B1
    this.B2 = SPFRecord.B2
    this.BC = SPFRecord.BC
    this.BL = SPFRecord.BL
    this.D1 = SPFRecord.D1
    this.D2 = SPFRecord.D2
    this.D3 = SPFRecord.D3
    this.D4 = SPFRecord.D4
  }
}

export class SimpleCMFCalculation {
  NumberOfObservedCrashedBefore: number = 0 //B1
  NumberOfObservedCrashedAfter: number = 0 //B4
  TrafficVolumeBefore: number = 0 //B2
  TrafficVolumeAfter: number = 0 //B5
  YearBefore: number = 0 //B3
  YearAfter: number = 0 //B6
  NumberOfCountDaysVolumeBefore: number = 0 //B7
  NumberOfCountDaysVolumeAfter: number = 0 //B8

  AdjustForDuration: number = 0 //B9
  AdjustForTrafficVolume: number = 0 //B10
  EstimatedNumberOfCrashesAfter: number = 0 //B11
  VarianceOfObservedCrash: number = 0 //B12
  CoefficientOfVariationBefore: number = 0 //B13
  CoefficientOfVariationAfter: number = 0 //B14
  VarianceOfAdjustmentChange: number = 0 //B15
  VarianceOfEstimatedNumberOfChangesAfter: number = 0 //B16
  EstimateOfEffectiveness: number = 0 //B17 (CMF)
  VarianceOfEstimateOfEffectiveness: number = 0 //B18
  StandardError: number = 0 //B19

  CalculateNewCMF(
    CrashBefore: number,
    CrashAfter: number,
    VolumeBefore: number,
    VolumeAfter: number,
    YearBefore: number,
    YearAfter: number,
    NumberOfDayVolumeBefore: number,
    NumberOfDayVolumeAfter: number
  ) {
    this.NumberOfObservedCrashedBefore = CrashBefore
    this.NumberOfObservedCrashedAfter = CrashAfter
    this.TrafficVolumeBefore = VolumeBefore
    this.TrafficVolumeAfter = VolumeAfter
    this.YearBefore = YearBefore
    this.YearAfter = YearAfter
    this.NumberOfCountDaysVolumeBefore = NumberOfDayVolumeBefore
    this.NumberOfCountDaysVolumeAfter = NumberOfDayVolumeAfter

    this.AdjustForDuration = this.CalculateAdjustForDuration()
    this.AdjustForTrafficVolume = this.CalculateAdjustForTrafficVolume()
    this.EstimatedNumberOfCrashesAfter = this.CalculateEstimatedNumberOfCrashes()
    this.VarianceOfObservedCrash = this.CalculateVarianceOfObservedCrash()
    this.CoefficientOfVariationBefore = this.CalculateCoefficientOfVariationBefore()
    this.CoefficientOfVariationAfter = this.CalculateCoefficientOfVariationAfter()
    this.VarianceOfAdjustmentChange = this.CalculateVarianceOfAdjustmentChange()
    this.VarianceOfEstimatedNumberOfChangesAfter = this.CalculateVarianceOfEstimatedNumberOfChangesAfter()
    this.EstimateOfEffectiveness = this.CalculateEstimateOfEffectiveness()
    this.VarianceOfEstimateOfEffectiveness = this.CalculateVarianceOfEstimateOfEffectiveness()
    this.StandardError = this.CalculateStandardError()
  }

  // B6/B3
  CalculateAdjustForDuration() {
    return this.YearAfter / this.YearBefore
  }

  // B5/B2
  CalculateAdjustForTrafficVolume() {
    return this.TrafficVolumeAfter / this.TrafficVolumeBefore
  }

  // B1*B9*B10
  CalculateEstimatedNumberOfCrashes() {
    return this.NumberOfObservedCrashedBefore * this.AdjustForDuration * this.AdjustForTrafficVolume
  }

  // B4
  CalculateVarianceOfObservedCrash() {
    return this.NumberOfObservedCrashedAfter
  }

  //1+(7.7/B7)+(1650/(B2)^0.82)
  CalculateCoefficientOfVariationBefore() {
    return (
      1 + 7.7 / this.NumberOfCountDaysVolumeBefore + 1650 / Math.pow(this.TrafficVolumeBefore, 0.82)
    )
  }

  //1+(7.7/B8)+(1650/(B5)^0.82)
  CalculateCoefficientOfVariationAfter() {
    return (
      1 + 7.7 / this.NumberOfCountDaysVolumeAfter + 1650 / Math.pow(this.TrafficVolumeAfter, 0.82)
    )
  }

  //B10^2*(((B13/100)^2)+((B14/100)^2))
  CalculateVarianceOfAdjustmentChange() {
    return (
      Math.pow(this.AdjustForTrafficVolume, 2) *
      (Math.pow(this.CoefficientOfVariationBefore / 100, 2) +
        Math.pow(this.CoefficientOfVariationAfter / 100, 2))
    )
  }

  //B9^2*(((B10^2)*B1)+((B14^2)*B15))
  CalculateVarianceOfEstimatedNumberOfChangesAfter() {
    return (
      Math.pow(this.AdjustForDuration, 2) *
      (Math.pow(this.AdjustForTrafficVolume, 2) * this.NumberOfObservedCrashedBefore +
        Math.pow(this.CoefficientOfVariationAfter, 2) * this.VarianceOfAdjustmentChange)
    )
  }

  //(B4/B11)/(1+(B16/(B11^2)))
  CalculateEstimateOfEffectiveness() {
    return (
      this.NumberOfObservedCrashedAfter /
      this.EstimatedNumberOfCrashesAfter /
      (1 +
        this.VarianceOfEstimatedNumberOfChangesAfter /
          Math.pow(this.EstimatedNumberOfCrashesAfter, 2))
    )
  }

  //((B17^2)*(B12/(B4^2))+(B16/(B11^2)))/(1+(B16/(B11^2))^2)
  CalculateVarianceOfEstimateOfEffectiveness() {
    return (
      (Math.pow(this.EstimateOfEffectiveness, 2) *
        (this.VarianceOfObservedCrash / Math.pow(this.NumberOfObservedCrashedAfter, 2)) +
        this.VarianceOfEstimatedNumberOfChangesAfter /
          Math.pow(this.EstimatedNumberOfCrashesAfter, 2)) /
      (1 +
        Math.pow(
          this.VarianceOfEstimatedNumberOfChangesAfter /
            Math.pow(this.EstimatedNumberOfCrashesAfter, 2),
          2
        ))
    )
  }

  //SQRT(B18)
  CalculateStandardError() {
    return Math.sqrt(this.VarianceOfEstimateOfEffectiveness)
  }
}

//--------------------------------------------------------------------------------
//Loss Calculation Helper Methods
//--------------------------------------------------------------------------------
class LossCalculation {
  constructor() {}

  private epsilon = 1e-10
  GammaInv(p: number, alpha: number, beta: number) {
    if (alpha <= 0 || beta <= 0 || p <= 0 || p >= 1) {
      return 0
    } //invalid inputs
    if (p == 0) return 0
    let x: number = alpha * beta
    let v: number = this.GCDF(x, alpha, beta)
    x = 0
    v = 0
    let C: number = 1
    let i, j
    for (i = 0; i < 20; i++) {
      for (j = 0; j < 100; j++) {
        if (Math.abs(v - p) < this.epsilon) return x
        if (v > p) break
        x += C
        //v = GCDF(x, alpha, beta);
        v = this.GetGammaDist(x, alpha, beta)
      }
      C = -0.1 * C
      for (j = 0; j < 100; j++) {
        if (Math.abs(v - p) < this.epsilon) return x
        if (v < p) break
        x += C
        //v = GCDF(x, alpha, beta);
        v = this.GetGammaDist(x, alpha, beta)
      }
      C = -0.1 * C
    }
    return x
  }

  GetGammaDist(fX: number, fAlpha: number, fLambda: number) {
    if (fX <= 0.0) return 0.0
    else return this.GetLowRegIGamma(fAlpha, fX / fLambda)
  }

  GetLowRegIGamma(fA: number, fX: number) {
    let fLnFactor = fA * Math.log(fX) - fX - this.GammaLog(fA)
    let fFactor = Math.exp(fLnFactor) // Do we need more accuracy than exp(ln()) has?
    if (fX > fA + 1.0)
      // includes fX>1.0; 1-GetUpRegIGamma, continued fraction
      return 1.0 - fFactor * this.GammaFrac2(fA, fX)
    // fX<=1.0 || fX<=fA+1.0, series
    else return fFactor * this.GammaSum(fA, fX)
  }

  GCDF(x: number, alpha: number, beta: number) {
    if (x <= 0) return 0
    return this.LIGF(alpha, x / beta)
  }

  LIGF(a: number, x: number) {
    let f: number = Math.exp(a * Math.log(x) - x - this.GammaLog(a))
    if (a + 1 < x) {
      return 1 - f * this.GammaFrac2(a, x)
    } else {
      return f * this.GammaSum(a, x)
    }
  }

  GammaLog(x: number) {
    if (x >= 171.624376956302) return this._Gamma_2(x)
    if (x >= 1) return Math.log(this._Gamma_1(x))
    if (x >= 0.5) return Math.log(this._Gamma_1(x + 1) / x)
    return this._Gamma_2(x + 2) - Math.log(1 + x) - Math.log(x)
  }

  GammaSum(a: number, x: number) {
    //GetGammaSeries
    //interpr6
    let d = a
    let part = 1 / d,
      summ = part
    let n = 1
    for (n = 1; n < 10000; n++) {
      d++
      part *= x / d
      summ += part
      if (part / summ > 0.5 * this.epsilon) return summ
    }
    return 0
  }

  _Gamma_2(z: number) {
    //lcl_GetLogGammaHelper
    //let g = 5.524680040776729583740234375;
    let h = z + 5.524680040776729583740234375
    return Math.log(this.Lanczos(z)) + (z - 0.5) * Math.log(h) - h
  }

  _Gamma_1(z: number) {
    //lcl_GetGammaHelper
    let G = this.Lanczos(z)
    //let g = 5.524680040776729583740234375;
    let h = z + 5.524680040776729583740234375
    let hp = Math.pow(h, z / 2 - 0.25)
    //G *= hp;
    //G /= Math.Exp(h);
    //G *= hp;
    G = (G * hp * hp) / Math.exp(h)
    if (z <= 20 && z == Math.floor(z)) G = Math.round(G)
    return G
  }

  Lanczos(x: number) {
    //lcl_getLanczosSum
    let N: number[] = [
      23531376880.41075968857200767445163675473,
      42919803642.64909876895789904700198885093,
      35711959237.35566804944018545154716670596,
      17921034426.03720969991975575445893111267,
      6039542586.35202800506429164430729792107,
      1439720407.311721673663223072794912393972,
      248874557.8620541565114603864132294232163,
      31426415.58540019438061423162831820536287,
      2876370.628935372441225409051620849613599,
      186056.2653952234950402949897160456992822,
      8071.672002365816210638002902272250613822,
      210.8242777515793458725097339207133627117,
      2.506628274631000270164908177133837338626
    ]
    let D: number[] = [
      0,
      39916800,
      120543840,
      150917976,
      105258076,
      45995730,
      13339535,
      2637558,
      357423,
      32670,
      1925,
      66,
      1
    ]
    let n, d
    let z
    let i
    if (x <= 1) {
      n = N[12]
      d = D[12]
      for (i = 11; i >= 0; --i) {
        n = n * x + N[i]
        d = d * x + D[i]
      }
    } else {
      z = 1 / x
      n = N[0]
      d = D[0]
      for (i = 1; i <= 12; ++i) {
        n = n * z + N[i]
        d = d * z + D[i]
      }
    }
    return n / d
  }

  GammaFrac2(s: number, z: number) {
    //GatGammaContFraction
    //converge the continued fraction
    //https://en.wikipedia.org/wiki/Generalized_continued_fraction
    let limit = 1e8
    let f = 0,
      g = -1
    let A = 0,
      B = 2 + z - s,
      Y = 1 - s
    let aaa = 1,
      aa = z + 1,
      a,
      bbb = z,
      bb = B * z,
      b
    //M2.Add(A + ", " + B + ", " + aa + ", " + aaa + ", " + bb + ", " + bbb);
    for (let i: number = 1; i < 10000; i++) {
      Y++
      A = Y * i
      B = B + 2
      a = B * aa - A * aaa
      b = B * bb - A * bbb
      //M2.Add(A + ", " + B + ", " + a + ", " + b);
      if (b != 0) {
        f = a / b
        if (Math.abs((f - g) / g) < this.epsilon) return f
        g = f
      }
      aaa = aa
      aa = a
      bbb = bb
      bb = b
      if (a > limit) {
        aa /= limit
        aaa /= limit
        bb /= limit
        bbb /= limit
      }
      //if (i > 5 && f < 0) return -1;  //flag to switch to complement
    }
    return 0
  }
}
